import { FE_BATCH_7_SEARCH_PLACEHOLDER_V2_250128 } from "@faire/retailer-settings/FE_BATCH_7_SEARCH_PLACEHOLDER_V2_250128";
import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
export var useSettingSearchPlaceholder = function() {
    return useSetting(FE_BATCH_7_SEARCH_PLACEHOLDER_V2_250128);
};
export var useAssignSettingSearchPlaceholder = function() {
    return useAssignSetting(FE_BATCH_7_SEARCH_PLACEHOLDER_V2_250128);
};
